// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2a101","messages":"Chat_messages__3JA3Q","dateDivider":"Chat_dateDivider__3NcDg"};